let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5gfK9")).then(() => parcelRequire('e94i2'));